// The strength of the keeper's own dosing product, from its label, as
// "per mL per US gallon" in dKH (alkalinity) or ppm (calcium, magnesium).
// Pure, so the unit conversions are tested rather than re-derived.
const GAL_PER_L = 1 / 3.785411784;

// Alkalinity labels print one of these. 1 meq/L = 2.8 dKH, and
// 1 dKH = 17.86 ppm as CaCO3.
export const ALK_LABEL_UNITS = [
  { k: 'dKH', label: 'dKH', toDkh: 1 },
  { k: 'meq', label: 'meq/L', toDkh: 2.8 },
  { k: 'ppm_caco3', label: 'ppm (as CaCO3)', toDkh: 1 / 17.86 },
];

function volumeInGallons(vol, volUnit) {
  const v = Number(vol);
  if (!Number.isFinite(v) || v <= 0) return null;
  return volUnit === 'L' ? v * GAL_PER_L : v;
}

// "ml mL raises it by rise riseUnit in vol volUnit" -> rise from 1 mL in
// one US gallon, or null when a number is missing.
export function labelStrengthPerMlPerGal({ ml, rise, riseUnit = 'dKH', vol, volUnit = 'gal' }) {
  const m = Number(ml);
  const r = Number(rise);
  const g = volumeInGallons(vol, volUnit);
  if (![m, r].every((n) => Number.isFinite(n) && n > 0) || !g) return null;
  const alk = ALK_LABEL_UNITS.find((u) => u.k === riseUnit);
  const riseStd = r * (alk ? alk.toDkh : 1);
  return (riseStd * g) / m;
}
labelStrengthPerMlPerGal.volumeInGallons = volumeInGallons;

// The strength read back per US gallon AND per litre, so a gallons-for-
// litres slip (3.8x, inside the server's strength band) shows before the
// product is saved. `strength` is per mL per US gallon.
export function strengthPerLitre(strength) {
  const n = Number(strength);
  return Number.isFinite(n) ? n / GAL_PER_L : null;
}
